<template>
  <div :class="$style.container">
    <Step :data="stepList" :step="step" />

    <!-- 开票明细 -->
    <Loading :loading="loading" :class="$style.invoice_details">
      <div :class="$style.invoice_title">开票明细</div>
      <div :class="$style.invoice_content">
        <template v-for="(item, index) in detail1">
          <div :class="$style.invoice_item" :key="index">
            {{ item.name }}：
            <span :class="index < 2 && 'theme-color'">
              {{ item.content || "-" }}
            </span>
          </div>
        </template>
      </div>
    </Loading>

    <Title title="关联交易" />

    <el-table
      ref="multipleTable"
      :data="showList"
      :fit="true"
      border
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        prop="createdTime"
        label="交易时间"
        width="80"
        align="center"
      />

      <el-table-column prop="typeName" label="类型" width="50" align="center" />

      <el-table-column label="交易金额" width="50" align="center">
        <template slot-scope="scope"> ￥{{ scope.row.payable }} </template>
      </el-table-column>

      <el-table-column label="可开票金额" width="50" align="center">
        <template slot-scope="scope">
          ￥{{ scope.row.invoiceAmount }}
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注" width="150" align="center" />
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import { getInvoiceDetail } from "@server";
import { MAP_RECEIPT_STATUS } from "@constant";

export default {
  name: "ReceiptDetail",
  props: {
    id: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      stepList: [
        "选择开票订单",
        "填写发票信息和地址",
        "后台审核，邮件发票",
        "签收快递，开票成功",
      ],
      step: -1,
      loading: false,
      detail1: [],
      page: 1,
      limit: 1,
      showList: [],
      total: 0,
    };
  },
  methods: {
    async getInvoiceDetail(page = 1) {
      this.loading = true;
      this.page = page;

      const params = {
        page,
        limit: this.limit,
        invoiceId: this.id,
      };
      const res = await getInvoiceDetail(params);
      const { code, data, message } = res;

      if (code === 200) {
        this.total = data.info?.total;
        this.showList = data.info?.list;
        this.detail1 = [
          {
            name: "开票金额",
            content: `￥${data.invoiceAmount}`,
          },
          {
            name: "发票状态",
            content: MAP_RECEIPT_STATUS[data.status],
          },
          {
            name: "开具类型",
            content: data.issuingType === 1 ? "类型" : "个人",
          },
          {
            name: "发票类型",
            content:
              data.invoiceType === 1 ? "增值税专用发票" : "增值税普通发票",
          },
          {
            name: "收件人",
            content: data.recipient,
          },
          {
            name: "邮箱",
            content: data.postCode,
          },
          {
            name: "快递公司",
            content: data.expressName,
          },
          {
            name: "发票抬头",
            content: data.header,
          },
          {
            name: "发票编号",
            content: data.invoiceNum,
          },
          {
            name: "申请时间",
            content: data.createdTime,
          },
          {
            name: "发票内容",
            content: data.contentType === 1 ? "信息服务费" : "域名服务费",
          },
          {
            name: "收取地址",
            content: data.address,
          },
          {
            name: "联系电话",
            content: data.phone,
          },
          {
            name: "快递编号",
            content: data.expressNumber,
          },
        ];
      } else {
        this.$message({ message, type: "error" });
      }
      this.loading = false;
    },
    handlePageChange(page) {
      this.getInvoiceDetail(page);
    },
  },
  created() {
    this.id && this.getInvoiceDetail();
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 300px;
  font-size: rem(14);
  color: #333;
  background: $white;

  .invoice_details {
    padding: rem(20) 0;
    min-height: rem(400);

    .invoice_title {
      padding: 0 rem(40);
      height: rem(70);
      min-height: 48px;
      font-size: max(rem(16), 14px);
      line-height: rem(70);
      background: #f6f6f9;
    }

    .invoice_content {
      columns: 2;
      column-gap: 0;
      border-left: $border-1;
      border-top: $border-1;
    }

    .invoice_item {
      height: rem(70);
      min-height: 48px;
      line-height: rem(70);
      text-indent: 2em;
      border-right: $border-1;
      border-bottom: $border-1;
    }
  }

  :global {
    .el-table {
      &::before {
        display: none;
      }

      ::v-deep.el-table__body-wrapper {
        min-height: unset;

        .el-table__cell {
          background-color: $white !important;
        }
      }
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }
}
</style>
